// TSL `time`(셰이더 전역 시계) 고정 장치(C8-7). three의 NodeFrame.update()는 렌더마다 performance.now() 차이를 time에 더한다.
// 그래서 환경 용암 바다·불 장판 흐름·불씨가 실시간으로 흘러, C8-6 고정 프레임 픽스처에서도 세트마다 표면이 조금씩 달랐다.
// 픽스처(view.qaFrame)가 켜진 동안만 update 직후 time을 게임 세계 시계(초)로 덮어쓴다 — 정상 플레이에서는 아무것도 바꾸지 않는다.
export interface NodeFrameLike { time: number; update(): unknown }

/** frame.update를 감싼다. pinned()가 숫자를 주면 그 프레임의 time은 그 값(초)이다. 되돌리기 함수를 준다. */
export function pinShaderClock(frame: NodeFrameLike, pinned: () => number | null): () => void {
  const orig = frame.update;
  frame.update = function (this: NodeFrameLike) {
    const r = orig.call(this);
    const p = pinned();
    if (p !== null && Number.isFinite(p)) this.time = p;
    return r;
  };
  return () => { frame.update = orig; };
}
